import React from 'react';

export const FlagGBIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 300" // Standard 2:1 ratio
    {...props}
  >
    <rect width="600" height="300" fill="#012169" rx="2"/> {/* Blue field */}
    {/* St Andrew's Saltire (Scotland) - White */}
    <g stroke="#FFFFFF" strokeWidth="60">
      <path d="M0 0 L600 300 M0 300 L600 0"/>
    </g>
    {/* St Patrick's Saltire (Ireland) - Red, counterchanged */}
    <g stroke="#C8102E" strokeWidth="40">
       <path d="M0 0 L600 300 M0 300 L600 0"/>
    </g>
     {/* St George's Cross (England) - White fimbriation */}
    <g stroke="#FFFFFF" strokeWidth="100">
      <path d="M300 0 L300 300 M0 150 L600 150"/>
    </g>
    {/* St George's Cross (England) - Red */}
    <g stroke="#C8102E" strokeWidth="60">
      <path d="M300 0 L300 300 M0 150 L600 150"/>
    </g>
  </svg>
);